import React, { useState } from 'react';
import DateInput from '../../../../common/DateInput'
import DatePicker from "react-datepicker";
import Paginator from '../../../../common/Paginator'

const EditAwards = ({ accomplishments, setAccomplishments, index, setIndex, addAccomplishments }) => {
    var accomplishment = accomplishments[index]
    return (
    <div >
        <div className="mg-b-5 mg-t-15">
        <div className="modal-subheader">Title</div>                
        <div className="mg-b-15"><input type="text" className="form-control" value={accomplishment.title} onChange={(e) => setAccomplishments(e.target.value, "title")}></input></div>
        <div className="row">
            <div className="col-md-7">
            <div className="modal-subheader">Issuer</div>                
            <div className="mg-b-15"><input value={accomplishment.association} onChange={(e) => setAccomplishments(e.target.value, "association")} type="text" className="form-control"></input></div>
            </div>
            <div className="col-md-5">
            <div className="modal-subheader">Date of Issue (Month/Year)</div>
                <DatePicker
                    selected={accomplishment.date}
                    onChange={(e) => setAccomplishments(e, "date")}
                    customInput={<DateInput/>}
                    showMonthYearPicker
                    dateFormat="MMMM, yyyy"
                />
            </div>
        </div>
        <div className="modal-subheader">Location</div>
        <div className="row mg-b-15">
            <div className="col-md-6">   
            <div className="modal-sublistheader mg-t-0">City/State</div>
            <div><input value={accomplishment.city} onChange={(e) => setAccomplishments(e.target.value, "city")} type="text" className="form-control"></input></div> 
            </div>
            <div className="col-md-6">
            <div className="modal-sublistheader mg-t-0">Country</div>
            <div><input value={accomplishment.country} onChange={(e) => setAccomplishments(e.target.value, "country")} type="text" className="form-control"></input></div>
            </div>   
        </div>   
        
        <div className="modal-subheader">Description</div>
    <div>
        <textarea className="textarea" value={accomplishment.description} onChange={(e) => setAccomplishments(e.target.value, "description")} style={{marginTop:'0px', marginBottom:'0px', height:'70px'}}></textarea>
    </div>                   
            <div className="row mg-t-15">
                <div className="col-md-8">
                
                    <button className="btn btn-mini btn-primary mg-r-25">
                        <i className="fas fa-info mg-r-5"></i>Upload Honours
                    </button>                        
                    <i className="fas fa-certificate text-c-success mg-r-10 c-pointer"></i>
                    <i className="fas fa-certificate text-c-success mg-r-10 c-pointer"></i>
                    <i className="fas fa-photo-video text-c-warning c-pointer"></i>
                
                </div>
                <div className="col-md-4">
                <div className="row f-right mg-r-5">
                    <div>
                        <i className="far fa-question-circle text-c-primary-active c-pointer mg-r-5 "></i>
                    </div>
                    <div className="text-small-primary">Supported documents</div>
                </div>
                </div>
            </div>                   
        
        </div>
        <div className="v-align">
            <div className="wd-pct-33">
                <Paginator index={index} length={accomplishments.length} onClick={setIndex}/>
            </div>
            <div className="wd-pct-33 text-center">{"Showing " + (index + 1) + " of " + accomplishments.length}</div>
            <div style={{marginLeft:'auto'}}>
                <button className="btn btn-mini btn-default" onClick={addAccomplishments}>
                    <i className="fas fa-plus mg-r-5"></i>Add Award
                    <span className="button-info">3</span>
                </button>
            </div>
        </div>
  </div>   
)}
export default EditAwards;